import styles from "./FavoriteProduct.module.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";

import top_love from "../../assets/images/top_love.jpg";

import useAxios from "../Hooks/useAxios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
const FavoriteProduct = () => {
  const backend_base = process.env.REACT_APP_API_BASE_URL;
  const axios = useAxios();
  const navigate = useNavigate();
  const [productsList, setProductsList] = useState([]);
  const [dataReload, setDataReload] = useState(false);
  const changeFavorite = (id) => {
    console.log(id);
    axios
      .post(backend_base + "/shop/product/favorite", {
        product: id,
      })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          const newProductsList = productsList.filter(
            (product) => product.id !== id
          );
          setProductsList(newProductsList);
          setDataReload((prev) => !prev);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  useEffect(() => {
    axios
      .get(backend_base + "/shop/product/favorite")
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("Success Getting Design Box Items");
          console.log(res.data.Favour_item_list);
          setProductsList(res.data.Favour_item_list);
        } else {
          console.log("Failed");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, [dataReload]);
  return (
    <>
      <Header />
      <div className={styles.main_div}>
        <div className={styles.box}>
          <div className={styles.box_header}>
            <img
              src={top_love}
              className={styles.header_icon}
              alt="headericon"
            />
            <div className={styles.header_text}>お気に入りアイテム</div>
          </div>
          {Array.isArray(productsList) && productsList.length === 0 && (
            <p className={styles.noFavorite}>お気に入り登録はありません。</p>
          )}
          <div
            className={styles.product_wrapper}
            style={
              productsList.length === 0
                ? { display: "block", height: "0", padding: "0" }
                : {}
            }
          >
            {Array.isArray(productsList) &&
              productsList.length > 0 &&
              productsList.map((item, index) => {
                console.log(item);
                return (
                  <div
                    onClick={() => {
                      navigate(
                        "/onlineshop?id=" +
                          item?.product?.product_category?.name
                      );
                    }}
                    key={index}
                    className={styles.single_product_main}
                  >
                    <img
                      className={styles.single_product_image}
                      src={item.product.product_category.images.split(",")[0]}
                      alt="img product"
                      crossOrigin="anonymous"
                    />
                    <div
                      onClick={(event) => {
                        event.stopPropagation();
                        changeFavorite(item?.product?.id);
                        setDataReload();
                      }}
                      className={styles.cross_div}
                    >
                      <ion-icon
                        className={styles.cross_icon}
                        name="close"
                      ></ion-icon>
                    </div>
                    <div className={styles.single_product_text}>
                      {item.product.title}
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
        <div
          onClick={() => {
            navigate("/top");
          }}
          className={styles.button1}
        >
          戻る
        </div>
      </div>
      <Footer />
    </>
  );
};

export default FavoriteProduct;
